<h2 mat-dialog-title>Your Session is About to Expire!</h2>
<mat-dialog-content>
    <p>You are about to be automatically logged out due to inactivity.</p>
    <p *ngIf="currentUser.timeoutIdle">
        Time remaining: <b>{{ currentUser.timeoutIdle }}</b> seconds
    </p>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button mat-button mat-dialog-close>Stay Logged In</button>
    <button mat-button [mat-dialog-close]="true" cdkFocusInitial>Logout</button>
</mat-dialog-actions>
